import * as ServiceStyles from './components/Service.css';
import * as DialogStyles from './components/Dialog/Dialog.css';
import { createTheme } from '../utils';
export const defaultTheme = {
    ServiceStyles,
    DialogStyles
};
export default defaultTheme;
export const { useTheme } = createTheme(defaultTheme);
